<div class="container_full_height">
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
        <div class="container-fluid">
            <a class="navbar-brand" [routerLink]="['/home']"><img src="../../../assets/images/my-posventa-logo.svg" alt="MY Posventa" class="logo-header"></a>
            <!--Header Recursive Buttons-->
            <div class="onlyLogoRG">
                <div class="rg-logo"><img src="../../../assets/images/rg-logo-nav.svg" alt="Renault Group"></div>
            </div>
        </div>
    </nav>
    <div class="cont_info_box">
        <div class="info__box_light">
            <img src="../../../assets/images/icons/icon-info-box.svg" class="icon-info">
            <p>Su número de cuenta no está habilitado para el uso de MY Posventa.</p>
        </div>
    </div>
</div>